import { Tab, Tabs } from "@mui/material";
import { useEffect, useState } from "react";
import { ContainerScreenGeneral } from "../../../components";
import InteraccionesPersonal from "./Charts/InteraccionesPersonal";
import InteraccionesPorUsuario from "./Charts/InteraccionesPorUsuario";
import { useMonitoreoPersonalStore } from "../../../store/monitoreoPersonal";
import { handlerDiasAgenteSelect, handlerGetAgentes, handlerUnAgente } from "../../../handlers/agentes.handler";
import { useGeneralAppStore } from "../../../store/generalAppStore";
import ModalInteraccionesDias from "./components/ModalInteraccionesDias";

const Agentes = () => {
  const [tabCurrent, setTabCurrent] = useState(1);

  const { loads, modals } = useGeneralAppStore();

  console.log(loads)
  // const { type } = useMonitoreoPersonalStore();

  const handleTabs = (event, newValue) => {
    setTabCurrent(newValue);
  };

  const [interaccionesPorAnio, setInteraccionesPorAnio] = useState();
  const [interaccionesCadaDia, setInteraccionesCadaDia] = useState();

  const [agentes, setAgentes] = useState(null);
  const [agenteSelect, setAgenteSelect] = useState(null);

  const [mesAgenteSelect, setMesAgenteSelect] = useState(null);

  const [filtrosNivel, setFiltrosNivel] = useState({
    nivel: 'anio',
    anio: '2025',
    mes: '',
    semana: '',
    dia: ''
  })

  useEffect(() => {
    if (agenteSelect) {
      handlerUnAgente({ nivel: 'anio', anio: '2025', user_id: agenteSelect?.user_id }, setInteraccionesPorAnio)
    }
  }, [agenteSelect])

  useEffect(() => {
    if (mesAgenteSelect) {
      handlerUnAgente({ nivel: 'mes', anio: '2025', user_id: agenteSelect?.user_id, mes: mesAgenteSelect?.numeroMes }, setInteraccionesCadaDia)
    }
  }, [mesAgenteSelect])

  useEffect(() => {
    if (!agentes) handlerGetAgentes(setAgentes)
  }, [])

  console.log(mesAgenteSelect)
  console.log(agenteSelect)

  // console.log(Object?.keys(interaccionesCadaDia)?.sort((a, b) => Number(a) - Number(b)))


  // console.log(agentes)
  // console.log(mesAgenteSelect)
  // console.log(interaccionesCadaDia)
  return (
    <ContainerScreenGeneral size={"full"} linkBack={"/menu-admin"} titulo={"Agentes"}>
      <div className="py-2 px-5">
        <p>Total de interacciones: {agentes?.total_interacciones}</p>
        <div className="d-flex gap-4">
          <div className="row" style={{ width: "550px" }}>
            {
              agentes?.interacciones_por_usuario?.map((agente) => {
                return (
                  <div key={agente?.user_id} className="col-6  p-1">

                    <div className=" border p-3 rounded w-100 d-flex justify-content-between  gap-3" onClick={() => {
                      setAgenteSelect(agente)

                    }}>

                      <p className="fw-bold mb-0" style={{ fontSize: "1rem" }}>{agente?.nombre}</p>
                      <p className="fw-bold text-success mb-0" style={{ fontSize: "1.2rem" }}> {agente?.interacciones_mvd + agente?.interacciones_backoffice}</p>
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className=" flex-grow-1  p-1" style={{}}>
            <div className="w-100 border rounded h-100">
              {
                !agenteSelect
                  ?
                  <div>Selecciones un agente</div>
                  :
                  <div>
                    <p className="m-0">Agente: {agenteSelect?.nombre}</p>
                    <p className="m-0">Total infracciones: {agenteSelect?.interacciones_mvd + agenteSelect?.interacciones_backoffice}</p>

                    {
                      interaccionesPorAnio && !loads.includes('agente') &&
                      <div className="d-flex flex-column gap-1">

                        {console.log(interaccionesPorAnio)}

                        {
                          Object?.keys(interaccionesPorAnio)?.sort((a, b) => Number(a) - Number(b))?.map((key, index) => {
                            const mesData = interaccionesPorAnio[key];
                            return (
                              <div key={index} className="p-2 border rounded"
                                onClick={() => { setMesAgenteSelect({ ...mesData, numeroMes: key }) }}
                              >
                                <div className=" ">
                                  {mesData?.nombre} - {mesData?.total} - <b className="text-success">{mesData?.mvd_aprobadas + mesData?.aprobadas_backoffice}</b> - <b className="text-danger">{mesData?.mvd_anuladas + mesData?.anuladas_backoffice}</b>
                                </div>

                              </div>
                            )
                          })
                        }

                      </div>
                    }

                  </div>
              }
            </div>

          </div>
        </div>
      </div>

      {console.log(mesAgenteSelect)}
      {
        modals?.includes('interacciones_dia') && <ModalInteraccionesDias interacciones={interaccionesCadaDia} mes={mesAgenteSelect?.numeroMes} nombreMes={mesAgenteSelect?.nombre} nombreAgente={agenteSelect?.nombre} />
      }
    </ContainerScreenGeneral>
  );
};

export default Agentes;
